export default "__VITE_PUBLIC_ASSET__fe2493f3__"